import {
  NavigationGuardNext,
  RouteLocationNormalized,
} from 'vue-router';
import { api } from '~/api';
import { useAuth } from '~/stores/auth.store';
import { AUTH_REDIRECT_URL } from '~/constants/auth.constants';

const toLogin = () => {
  window.location.href = AUTH_REDIRECT_URL;
};

export const authGuard = (publicPaths: string[]) => {
  return async (
    to: RouteLocationNormalized,
    _from: RouteLocationNormalized,
    next: NavigationGuardNext,
  ) => {
    const auth = useAuth();
    const isPublic = publicPaths.includes(to.path);

    if (isPublic) return next();

    let status: number
    let redirectUrl: string
    try {
      const res = await api.auth.checkAuth()
      status = res.status
      redirectUrl = res.data?.url || ''
    } catch (err) {
      console.error('checkAuth failed:', err)
      status = 401
      redirectUrl = ''
    }

    if (status === 401) {
      auth.clearAuthData()
      toLogin()
      return
    }

    if (redirectUrl) {
      auth.clearAuthData()
      window.location.href = redirectUrl
      return
    }

    if (!auth.authorized) {
      try {
        await auth.fetchUser()
      } catch (err) {
        console.error('fetchUser failed:', err)
      }
    }

    if (!auth.authorized) {
      auth.clearAuthData()
      toLogin()
      return
    }

    return next()
  };
};
